export const H5_BASE_CSS_VARS = {
  "theme-website-h5-color-text": "var(--theme-website-color-text-primary)",
  "theme-website-h5-font-family": "InterVariable",
  "theme-website-h5-font-size": "1.75rem",
  "theme-website-h5-font-weight": "600",
  "theme-website-h5-line-height": "1.3",
  "theme-website-h5-letter-spacing": "0",
};
